import { OperatingHours } from 'src/app/simulator-booking/models/operating-hours';
import { GolfTechType } from './golftech-type.enum';
import { CreditCardFeeType } from './creditcard-fee-type.enum';

export class UserData {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    golfTechType: GolfTechType;
    venmoUsername: string;
    venmoQrCode: File;
    venmoQrCodeImage: any;
    defaultTheme: boolean;
    stripeAccountId: string;
    userAccountId: string;
    organizationId: string;
    auth0Id: string;
    apiKey: string;
    organizationName: string;
    operatingHours: OperatingHours[];
    permissions: Permissions;
    timeZone: string;
    creditCardFeeType: CreditCardFeeType;
    creditCardFee: number;
}

export class Permissions{
    simulatorCount: number;
    reportingFunctionality: boolean;
    digitalWaiverFunctionality: boolean;
    supportFunctionality: boolean;
    membershipFunctionality: boolean;
    leagueFunctionality: boolean;
}

